import Vue from "vue";
import VueRouter from "vue-router";

import { store } from "./store";

const DefaultLayout = () =>
  import("@/layouts/" + process.env.VUE_APP_DEFAULT_LAYOUT);

const Login = () => import("@/pages/Login");
const AdminPage = () => import("@/pages/AdminPage");
const Main = () => import("@/pages/Main");
const Monitor = () => import("@/pages/Monitor");
const GoLiveVersions = () => import("@/pages/GoLiveVersions");
const PresenterDisplay = () => import("@/pages/PresenterDisplay");

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      async beforeEnter(to, from, next) {
        next("/main");
      },
    },
    {
      name: "login",
      path: "/login",
      component: Login,
      meta: {
        title: "Login",
        layout: DefaultLayout,
      },
    },
    {
      name: "admin",
      path: "/admin",
      component: AdminPage,
      meta: {
        title: "Admin",
        layout: DefaultLayout,
        validateToken: true,
        requiresAdmin: true,
      },
    },
    {
      name: "main",
      path: "/main",
      props: true,
      component: Main,
      meta: {
        title: "GoLive",
        layout: DefaultLayout,

        validateToken: true,
        //  requiresAdmin: true
      },
    },
    {
      name: "monitor",
      path: "/monitor",
      props: true,
      component: Monitor,
      meta: {
        title: "GoLive",
        layout: DefaultLayout,
        validateToken: true,
        requiresAdmin: true,
      },
    },
    {
      name: "downloads",
      path: "/downloads",
      props: true,
      component: GoLiveVersions,
      meta: {
        title: "GoLive",
        layout: DefaultLayout,
        validateToken: true,
      },
    },

    {
      name: "PresenterDisplay",
      path: "/display",
      props: true,
      component: PresenterDisplay,
      meta: {
        title: "Tally",
        validateToken: true,
        requiresAdmin: true
      },
    },
    
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // check authorised
  let allowNext = true;

  if (to.meta.validateToken) {
    try {
      await store.dispatch("auth/validateToken");
    } catch (err) {
      console.error(err.message);
      allowNext = false;
    }
  }

  if (to.meta.requiresAdmin && !store.getters["auth/isAdmin"])
    allowNext = false;
  if (to.meta.requiresHost && !store.getters["auth/isHost"]) allowNext = false;

  if (!allowNext) {
    next({
      path: "/login",
      query: { nextPage: to.fullPath },
    });
  } else {
    next();
  }
});

export default router;
